import request from '@/utils/request'

export function listAssets(data) {
  return request({ url: '/crmAsset/list', method: 'post', data })
}

export function listMyAssets(data) {
  return request({ url: '/crmAsset/my/list', method: 'post', data })
}

export function getAssetOverview() {
  return request({ url: '/crmAsset/overview', method: 'get' })
}

export function getAssetTodoList() {
  return request({ url: '/crmAsset/todo/list', method: 'get' })
}

export function getAssetDetail(id) {
  return request({ url: `/crmAsset/detail/${id}`, method: 'get' })
}

export function listPersonnelAssets(keyword) {
  return request({ url: '/crmAsset/personnel/summary', method: 'get', params: { keyword } })
}

export function listDepartmentAssets(keyword) {
  return request({ url: '/crmAsset/department/summary', method: 'get', params: { keyword } })
}

export function saveAsset(data) {
  return request({ url: '/crmAsset/save', method: 'post', data })
}

export function listAssetCategories(includeDisabled = false) {
  return request({ url: '/crmAsset/category/list', method: 'get', params: { includeDisabled } })
}

export function submitAssetClaim(data) {
  return request({ url: '/crmAsset/claim/submit', method: 'post', data })
}

export function listMyAssetClaims() {
  return request({ url: '/crmAsset/claim/my', method: 'get' })
}

export function listPendingAssetClaims() {
  return request({ url: '/crmAsset/claim/pending', method: 'get' })
}

export function listAssetClaims() {
  return request({ url: '/crmAsset/claim/list', method: 'get' })
}

export function handleAssetClaim(data) {
  return request({ url: '/crmAsset/claim/handle', method: 'post', data })
}

export function cancelAssetClaim(id) {
  return request({ url: `/crmAsset/claim/${id}/cancel`, method: 'post' })
}

export function saveAssetCategory(data) {
  return request({ url: '/crmAsset/category/save', method: 'post', data })
}

export function issueAsset(data) {
  return request({ url: '/crmAsset/issue', method: 'post', data })
}

export function transferAsset(data) {
  return request({ url: '/crmAsset/transfer', method: 'post', data })
}

export function returnAsset(data) {
  return request({ url: '/crmAsset/return', method: 'post', data })
}

export function confirmAssetOperation(data) {
  return request({ url: '/crmAsset/confirm', method: 'post', data })
}

export function acceptAssetReturn(data) {
  return request({ url: '/crmAsset/return/accept', method: 'post', data })
}

export function getMyPendingAssetOperations() {
  return request({ url: '/crmAsset/my/pendingOperations', method: 'get' })
}

export function getOutstandingAssets(userId) {
  return request({ url: '/crmAsset/outstanding', method: 'get', params: { userId } })
}

export function createAssetStocktake(data) {
  return request({ url: '/crmAsset/stocktake/create', method: 'post', data })
}

export function listAssetStocktakes() {
  return request({ url: '/crmAsset/stocktake/list', method: 'get' })
}

export function getAssetStocktakeItems(id) {
  return request({ url: `/crmAsset/stocktake/${id}/items`, method: 'get' })
}

export function getMyPendingStocktakeItems() {
  return request({ url: '/crmAsset/stocktake/myPending', method: 'get' })
}

export function confirmAssetStocktake(data) {
  return request({ url: '/crmAsset/stocktake/confirm', method: 'post', data })
}

export function closeAssetStocktake(id) {
  return request({ url: `/crmAsset/stocktake/${id}/close`, method: 'post' })
}

export function listAssetRepairs(data) {
  return request({ url: '/crmAsset/repair/list', method: 'post', data })
}

export function listMyAssetRepairs(data) {
  return request({ url: '/crmAsset/repair/my/list', method: 'post', data })
}

export function submitAssetRepair(data) {
  return request({ url: '/crmAsset/repair/submit', method: 'post', data })
}

export function recordAssetRepair(data) {
  return request({ url: '/crmAsset/repair/record', method: 'post', data })
}

export function inspectAssetRepair(data) {
  return request({ url: '/crmAsset/repair/inspect', method: 'post', data })
}

export function completeAssetDisposal(data) {
  return request({ url: '/crmAsset/scrap/disposal/complete', method: 'post', data })
}
